// T27 — Leaderboard: agent rankings by intel.
import { el, mount } from "../lib/dom";
import { getLeaderboard } from "../lib/data";
import { nav } from "../components/nav";

export async function renderLeaderboard(): Promise<void> {
  mount(el("div", {}, el("div.card", {}, el("p.tiny.dim", {}, "Decrypting rankings…")), nav("/map")));

  const data = await getLeaderboard({});
  const medal = (r: number) => (r === 1 ? "🥇" : r === 2 ? "🥈" : r === 3 ? "🥉" : `#${r}`);

  const rows = data.leaderboard.map((g) =>
    el("div.row", {
      style: `justify-content:space-between;padding:12px 0;border-top:1px solid var(--line)${g.isMe ? ";color:var(--amber)" : ""}`,
    },
      el("div.row", { style: "gap:12px;min-width:0;flex:1" },
        el("span.mono", { style: "width:34px;flex:none" }, medal(g.rank)),
        el("span", { style: "min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap" }, g.codename, g.isMe ? " (you)" : ""),
      ),
      el("span.hud__intel", { style: "flex:none;padding-left:10px" }, `${g.totalIntel} ◆`),
    ),
  );

  mount(el("div", {},
    el("h2", {}, "// AGENT RANKINGS"),
    el("div.card", {}, ...rows),
    nav("/map"),
  ));
}
